import { z } from "zod";
import { pinned } from "./pin";

/**
 * Structured ship-from address surfaced on listing response shapes per
 * ADR_LISTING_SHIP_FROM_ADDRESS.md (Phase 2). Replaces the legacy free-
 * text `listings.location` column.
 *
 * Resolution (server-side):
 *  1. If `listings.ship_from_address_id` is set + row not deleted → that row.
 *  2. Else → seller's `address_book.is_main` row.
 *  3. Else → null (orphan listing).
 *
 * Country is ISO-2 (mirrors `address_book.country`). Clients (web +
 * mobile) map ISO-2 → display name via their own country library.
 */
export type ShipFromAddress = {
  city: string | null;
  state: string | null;
  country: string | null; // ISO-2
} | null;

export const ShipFromAddressSchema = pinned<ShipFromAddress>()(
  z
    .object({
      city: z.string().nullable(),
      state: z.string().nullable(),
      country: z.string().nullable(),
    })
    .nullable(),
);
